import React from 'react';
import Icon from 'components/AppIcon';
import Button from 'components/ui/Button';
import Select from 'components/ui/Select';

const ServiceFilters = ({ 
  filters, 
  onFilterChange, 
  onClearFilters,
  serviceStats,
  categoryOptions = [],
}) => {

  const statusOptions = [
    { value: '', label: 'All Status' },
    { value: 'active', label: 'Active Only' },
    { value: 'inactive', label: 'Inactive Only' }
  ];

  const sortOptions = [
    { value: 'name', label: 'Name (A-Z)' },
    { value: 'price-low', label: 'Price (Low to High)' },
    { value: 'price-high', label: 'Price (High to Low)' },
    { value: 'duration', label: 'Duration' },
    { value: 'popularity', label: 'Popularity' }
  ];

  const hasActiveFilters = filters?.category || filters?.status || filters?.sortBy !== 'name';

  return (
    <div className="bg-card border border-border rounded-lg p-6 elevation-1">
      {/* Filter Header */}
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center space-x-2">
          <Icon name="Filter" size={20} className="text-primary" />
          <h3 className="text-lg font-semibold text-foreground">Filters</h3>
        </div>
        {hasActiveFilters && (
          <Button
            variant="ghost"
            size="sm"
            onClick={onClearFilters}
            iconName="X"
            iconPosition="left"
            iconSize={14}
            className="text-muted-foreground hover:text-foreground"
          >
            Clear
          </Button>
        )}
      </div>
      {/* Service Statistics */}
      <div className="mb-6 p-4 bg-muted rounded-lg">
        <h4 className="text-sm font-medium text-foreground mb-3">Service Overview</h4>
        <div className="grid grid-cols-1 gap-3">
          <div className="flex items-center justify-between">
            <span className="text-sm text-muted-foreground">Total Services</span>
            <span className="text-sm font-medium text-foreground">
              {serviceStats?.total}
            </span>
          </div>
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-2">
              <div className="status-indicator active"></div>
              <span className="text-sm text-muted-foreground">Active</span>
            </div>
            <span className="text-sm font-medium text-success">
              {serviceStats?.active}
            </span>
          </div>
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-2">
              <div className="status-indicator inactive"></div>
              <span className="text-sm text-muted-foreground">Inactive</span>
            </div>
            <span className="text-sm font-medium text-muted-foreground">
              {serviceStats?.inactive}
            </span>
          </div>
          <div className="flex items-center justify-between pt-2 border-t border-border">
            <span className="text-sm text-muted-foreground">Avg. Price</span>
            <span className="text-sm font-medium text-primary">
              R{serviceStats?.averagePrice}
            </span>
          </div>
        </div>
      </div>
      {/* Filter Controls */}
      <div className="space-y-4">
        {/* Category Filter */}
        <Select
          label="Category"
          options={categoryOptions}
          value={filters?.category}
          onChange={(value) => onFilterChange('category', value)}
        />

        {/* Status Filter */}
        <Select
          label="Status"
          options={statusOptions}
          value={filters?.status}
          onChange={(value) => onFilterChange('status', value)}
        />

        {/* Sort By */}
        <Select
          label="Sort By"
          options={sortOptions}
          value={filters?.sortBy}
          onChange={(value) => onFilterChange('sortBy', value)}
        />
      </div>
      {/* Revenue Breakdown */}
      {/* <div className="mt-6 pt-6 border-t border-border">
        <h4 className="text-sm font-medium text-foreground mb-3">Revenue by Category</h4>
        <div className="space-y-3">
          {serviceStats?.revenueByCategory?.map((category) => (
            <div key={category?.name} className="flex items-center justify-between">
              <div className="flex items-center space-x-2">
                <div 
                  className="w-3 h-3 rounded-full"
                  style={{ backgroundColor: category?.color }}
                ></div>
                <span className="text-sm text-muted-foreground">
                  {category?.name}
                </span>
              </div>
              <div className="text-right">
                <div className="text-sm font-medium text-foreground">
                  ${category?.revenue}
                </div>
                <div className="text-xs text-muted-foreground">
                  {category?.percentage}%
                </div>
              </div>
            </div>
          ))}
        </div>
      </div> */}
      {/* Quick Actions */}
      {/* <div className="mt-6 pt-6 border-t border-border">
        <h4 className="text-sm font-medium text-foreground mb-3">Quick Actions</h4>
        <div className="space-y-2">
          <Button
            variant="ghost"
            size="sm"
            onClick={() => onFilterChange('status', 'active')}
            iconName="Eye"
            iconPosition="left"
            iconSize={14}
            className="w-full justify-start"
          >
            Show Active Only
          </Button>
          <Button
            variant="ghost"
            size="sm"
            onClick={() => onFilterChange('sortBy', 'price-high')}
            iconName="TrendingUp"
            iconPosition="left"
            iconSize={14}
            className="w-full justify-start"
          >
            Sort by Price (High)
          </Button>
          <Button
            variant="ghost"
            size="sm"
            onClick={() => onFilterChange('category', 'premium')}
            iconName="Star"
            iconPosition="left"
            iconSize={14}
            className="w-full justify-start"
          >
            Premium Services
          </Button>
        </div>
      </div> */}
    </div>
  );
};

export default ServiceFilters;